const convertDate = ({ timestamp, withTime = false }: { timestamp?: number; withTime?: boolean }): string => {
	if (timestamp === undefined) return "-";

	const date = new Date(timestamp * 1000); // timestamp в секундах
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0"); // месяцы с 0
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	return `${year}-${month}-${day} ${withTime ? `${hours}:${minutes}` : ``}`;
};

export default convertDate;
